import { createActions, createState, createReducer } from 'reduxsauce-crud'

export const AllCentersRedux = createActions({},
  {
    prefix: 'ALL_CENTERS_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = AllCentersRedux
export const AllCentersTypes = Types
export default Creators

export const INITIAL_STATE = createState({}, {
  get: true,
})

export const reducer = createReducer(INITIAL_STATE, {},
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/AllCentersRedux.js